import appParameters from '../../components/utils/AppParameters';

const platformDetection = {
    //Safari with IOS 13: Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/ 13.0.1 Safari/605.1.15
    //Safari with IOS < 13: Mozilla/5.0 (iPad; CPU OS 13_1_2 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.1 Mobile/15E148 Safari/604.1
    isIOS() {
        var IOS = (navigator.userAgent.match(/iPad/i) != null) || (navigator.userAgent.indexOf('Mac') != -1 && navigator.maxTouchPoints > 1);

        return IOS;
    },
    //Windows Chrome : Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/61.0.3163.100 Safari/537.36
    //WebView IOS: Mozilla/5.0 (iPad; CPU OS 9_3_5 like Mac OS X) AppleWebKit/601 (KHTML, like Gecko) Mobile/13G36
    isIOSApp() {
        var IOS = (navigator.userAgent.match(/iPad/i) != null) || (navigator.userAgent.indexOf('Mac') != -1 && navigator.maxTouchPoints > 1);
        const ua = window.navigator.userAgent;
        const isBrowser = ua.indexOf('Safari') > 0;

        if (IOS && !isBrowser)
            return true;
        else
            return false;
    },
    isMac() {
        const ua = window.navigator.userAgent;

        if ((ua.indexOf('Mac') > 0 || ua.indexOf('mac') > 0) && !(navigator.maxTouchPoints > 1))
            return true;
        else
            return false;
    },
    isIE() {
        const ua = window.navigator.userAgent;
        const msie = ua.indexOf('MSIE '); // IE 10 or older
        const trident = ua.indexOf('Trident/'); // IE 11

        if (msie > 0 || trident > 0)
            return true;
        else
            return false;

    },
    isEdge() {
        const ua = window.navigator.userAgent;

        if (ua.indexOf('Edg') > 0)
            return true;
        else
            return false;

    },
    isFirefox() {
        const ua = window.navigator.userAgent;

        if (ua.indexOf('Firefox') > 0)
            return true;
        else
            return false;

    },
    isSafari() {
        if (navigator.userAgent.search('Safari') >= 0 && navigator.userAgent.search('Chrome') < 0)
            return true;
        else
            return false;

    },
    isChrome() {
        if (window.chrome && window.chrome.webstore)
            return true;
        else
            return false;
    },
    isChromeBook() {
        const ua = window.navigator.userAgent;
        const chromeBook = ua.indexOf('CrOS');

        if (chromeBook > 0)
            return true;
        else
            return false;
    },
    isWindowSourface() {
        const navigator = window.navigator;
        const ua = window.navigator.userAgent;
        var isTouchDevice   = ('ontouchstart' in window || navigator.msMaxTouchPoints > 0 || navigator.maxTouchPoints || ua.indexOf('Touch') != -1 || ua.indexOf('ARM') != -1 || ua.indexOf('Tablet') != -1);

        if (isTouchDevice == true)
            return true;
        else
            return false;
    },
    isMixedDevice() {
        if (this.isChromeBook() == true || this.isWindowSourface() == true)
            return true;
        else
            return false;
    },
    isTouchableDevice() {
        // var isTouchDevice = (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
        //
        // if (isTouchDevice)
        //     return true;

        if (this.isChromeBook() || this.isIOS() == true || this.isWindowSourface() == true)
            return true;
        else
            return false;
    },
    isAndroid() {
        var ua = window.navigator.userAgent.toLowerCase();
        var isAndroid = ua.indexOf('android') > -1;

        return isAndroid;
    },
    isSafariNonIOS() {
        if (!this.isIOS() && this.isSafari())
            return true;
        else
            return false;
    },
    showSafariAlert: false
};

export default platformDetection;



/** WEBPACK FOOTER **
 ** ./src/components/utils/PlatformDetection.js
 **/